import { ref } from 'vue'

export const shippingCost = ref(0)
